var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgParking(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M452,0H60C26.916,0,0,26.916,0,60v392c0,33.084,26.916,60,60,60h392c33.084,0,60-26.916,60-60V60     C512,26.916,485.084,0,452,0z M472,452c0,11.028-8.972,20-20,20H60c-11.028,0-20-8.972-20-20V60c0-11.028,8.972-20,20-20h392     c11.028,0,20,8.972,20,20V452z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M286,100H146v312h40V300h100c55.14,0,100-44.86,100-100S341.14,100,286,100z M286,260H186V140h100     c33.084,0,60,26.916,60,60S319.084,260,286,260z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParking);
export default __webpack_public_path__ + "static/media/parking.9f9586b6.svg";
export { ForwardRef as ReactComponent };